__turbopack_context__.v({
  "container": "GalleryStackBlock-module__RupCQa__container",
  "fadeInItems": "GalleryStackBlock-module__RupCQa__fadeInItems",
  "half": "GalleryStackBlock-module__RupCQa__half",
  "item": "GalleryStackBlock-module__RupCQa__item",
  "media": "GalleryStackBlock-module__RupCQa__media",
  "mediaHalf": "GalleryStackBlock-module__RupCQa__mediaHalf",
  "mediaLandscape": "GalleryStackBlock-module__RupCQa__mediaLandscape",
  "spacing--lg": "GalleryStackBlock-module__RupCQa__spacing--lg",
  "spacing--md": "GalleryStackBlock-module__RupCQa__spacing--md",
  "spacing--sm": "GalleryStackBlock-module__RupCQa__spacing--sm",
  "spacing--xl": "GalleryStackBlock-module__RupCQa__spacing--xl",
  "spacing--xs": "GalleryStackBlock-module__RupCQa__spacing--xs",
  "spacing--xxl": "GalleryStackBlock-module__RupCQa__spacing--xxl",
  "spacing--xxs": "GalleryStackBlock-module__RupCQa__spacing--xxs",
  "spacing--xxxl": "GalleryStackBlock-module__RupCQa__spacing--xxxl",
  "spacing--xxxs": "GalleryStackBlock-module__RupCQa__spacing--xxxs",
});
